import React from "react";
import { Box, SpaceBetween } from "@cloudscape-design/components";

const FinancePaymentTypeMappingHelp = () => (
  <SpaceBetween size="m">
    <Box>
      <strong>Purpose</strong>
      <p>
        Configure how interventions map to payment types and which validation rules apply before finance submission.
      </p>
    </Box>
    <Box>
      <strong>Intervention map tab</strong>
      <ul>
        <li>`Allowed payment types` limits which payment types can be used for an intervention.</li>
        <li>`Default lines` pre-seeds payment line types for that intervention.</li>
        <li>`Auto-add?` controls whether an intervention is included by default in Application Assessment step 2.</li>
      </ul>
    </Box>
    <Box>
      <strong>Payment types tab</strong>
      <ul>
        <li>Define canonical payment type `code`, `label`, and optional notes.</li>
        <li>Set recurrence policy per type (`not allowed`, `optional`, `required`).</li>
        <li>Set submission timing (`start`, `end`, `recurrence`, or `manual trigger`).</li>
        <li>Use the Evidence tab to configure documents separately for each payment type.</li>
      </ul>
    </Box>
    <Box>
      <strong>Evidence tab</strong>
      <ul>
        <li>Choose a payment type and add or remove evidence requirements, including CFA and EFT.</li>
        <li>Choose Attach to email when Finance needs the file, or On file is sufficient when a matching document only needs to be held in PATH.</li>
        <li>Choose Warn and allow sending or Block sending for each missing document. Drafts can still be saved.</li>
        <li>All payees applies to the whole payment type. Payee-specific requirements apply in addition; inspect those scopes when changing a rule.</li>
        <li>New payment types start with CFA and EFT attached when available, with warnings if missing. Existing other requirements start as on-file warnings. Saved choices remain authoritative.</li>
        <li>Case managers can attach other accessible documents freely. There is no optional-document catalogue.</li>
      </ul>
    </Box>
    <Box>
      <strong>Notes and metadata tab</strong>
      <ul>
        <li>Track mapping version notes for audit/review context.</li>
        <li>Use `Generated on` and update timestamps to confirm freshness after saves.</li>
      </ul>
    </Box>
    <Box>
      <strong>Operational impact</strong>
      <p>
        These settings affect new and editable payment emails. Evidence must match the payment context:
        the applicable signed CFA, originating application, and attendance period where relevant.
        Warning-only requirements do not prevent sending. Funding controls and separate post-payment evidence rules still apply.
      </p>
    </Box>
  </SpaceBetween>
);

FinancePaymentTypeMappingHelp.aiContext =
  "Explain Finance Settings Payment type mapping: intervention-to-payment-type mapping, default line seeding, Auto-add behavior for assessment step 2, payment-type recurrence policy, submission timing, per-payment-type evidence requirements including editable CFA/EFT, Attach to email versus On file is sufficient, Warn and allow sending versus Block sending, additive payee-specific rules, unrestricted additional attachments within normal document access, and unchanged post-payment controls. First-release defaults warn without blocking and automatically attach only matching CFA/EFT. Existing saved choices are not reset.";

export default FinancePaymentTypeMappingHelp;
